import { PDFDocument } from 'pdf-lib'

/**
 * Filters a PDF to only include specified pages.
 *
 * @param pdfBlob - The original PDF as a Blob
 * @param pageIndices - 0-indexed page indices to keep
 * @returns A new PDF Blob containing only the specified pages
 */
export async function filterPdfToPages(
  pdfBlob: Blob,
  pageIndices: number[],
): Promise<Blob> {
  if (pageIndices.length === 0) {
    throw new Error('No pages to keep')
  }

  const buffer = await pdfBlob.arrayBuffer()
  const sourcePdf = await PDFDocument.load(new Uint8Array(buffer))
  const filteredPdf = await PDFDocument.create()

  const validIndices = pageIndices.filter(
    (i) => i >= 0 && i < sourcePdf.getPageCount(),
  )

  if (validIndices.length === 0) {
    throw new Error('No valid pages to keep')
  }

  const pages = await filteredPdf.copyPages(sourcePdf, validIndices)
  pages.forEach((page) => filteredPdf.addPage(page))

  const pdfBytes = await filteredPdf.save()
  return new Blob([new Uint8Array(pdfBytes)], { type: 'application/pdf' })
}
